import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import OtpInput from "@bachdgvn/vue-otp-input";
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import {mapState} from 'vuex';
import Multiselect from 'vue-multiselect'
import Loading from 'vue-loading-overlay';
import BabelPolyfill from '@babel/polyfill';
import VueHtml2pdf from 'vue-html2pdf'
import 'vue-loading-overlay/dist/vue-loading.css';
// import CKEditor from '@ckeditor/ckeditor5-vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';
  // register globally 
// import stores from './stores/index'
// import RequestPlugin from './plugin/requestplugin'

import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faUserSecret, 
  faEye,
  faEyeSlash,
  faEdit,
  faTrash, 
  faFile,
  faBell, 
  faUsers, 
  faUser, 
  faPlus, 
  faCheck, 
  faTimes, 
  faEnvelope, 
  faPaperPlane, 
  faCoins, 
  faArrowUp, 
  faCog, 
  faSearch, 
  faPaperclip, 
  faCalendar, 
  faDatabase , 
  faTachometerAlt, 
  faUserCog, 
  faFileAlt, 
  faWallet, 
  faClock, 
  faBullhorn, 
  faKey, 
  faChevronDown,
  faArrowRight,
  faArrowDown, 
  faMapMarkedAlt, 
  faMoneyBill, 
  faHistory, 
  faGavel, 
  faUpload, 
  faPaste,
  faIdCard
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSweetalert2 from 'vue-sweetalert2';
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import Lang from './lang/indo-lang.json';
import Vuelidate from 'vuelidate'; 

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
// import VueHtmlToPaper from 'vue-html-to-paper';
import VueHtml2Canvas from 'vue-html2canvas';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css'
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtml2Canvas);
Vue.use(BabelPolyfill);

// Vue.use(VueHtmlToPaper, options);

// or, using the defaults with no stylesheet
// Vue.use(VueHtmlToPaper);
 
library.add(faBell,faKey,faEye,faEyeSlash,faUserSecret,faEdit,faTrash,faUser,faUsers,faFile,faPlus,faCheck,faTimes,faEnvelope,faPaperPlane,faCoins,faArrowUp,faCog,faSearch, faPaperclip, faCalendar, faDatabase, faTachometerAlt, faUserCog, faFileAlt, faWallet, faClock, faBullhorn, faChevronDown,faArrowRight,faArrowDown, faMapMarkedAlt, faMoneyBill, faHistory, faGavel, faUpload, faPaste, faIdCard);
window.Vue = require('vue');
Vue.use(VueHtml2pdf)
Vue.use(Vuelidate);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.performance = true;
Vue.use(Loading);
Vue.use(VueSweetalert2);
Vue.use(CoreuiVue)
Vue.use(mapState)
Vue.use( CKEditor );
// Vue.use(RequestPlugin);
Vue.component("v-otp-input", OtpInput);
Vue.component('multiselect', Multiselect)
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.prototype.$log = console.log.bind(console)
// Vue.prototype.$baseUrl = Lang;
Vue.prototype.$baseUrlFoUser = 'https://37.44.244.162:81/';

// router.beforeEach((to, from, next) => {
//   const publicPages = ['Login','LupaPassword','PasswordBaru','Verifikasi'];
//   const authRequired= !publicPages.includes(to.name);
//   const loggedIn = localStorage.getItem('user');

//   // trying to access a restricted page + not logged in
//   // redirect to login page
//   if (authRequired && !loggedIn) {
//     window.location.href="#/pages/login"
//   } else {
//     next();
//   }
// });
/**
 * 
 * BAHASA INDONESIA
 * Cara Paggilnya this.$indolang.{nama propertynya}
 */
  
Vue.prototype.$string = Lang;

/**
 * 
 * BAHASA INGGRIS
 * 
 */
// Vue.prototype.$indoLang = Lang;
export const bus = new Vue();
new Vue({
  el: '#app',
  data : function() {
    return { 
      indoLang : {
        header : "hai"
      }
    }
  },
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
